/* eslint-disable react/prop-types */
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { USAGE_TYPE_LABELS, USAGE_TYPES } from '../featureToggleConstants'

function UsageTypeSelect({ labelId, value, onChange }) {
  return (
    <FormControl fullWidth margin="normal">
      <InputLabel id={labelId}>Tipo de uso</InputLabel>
      <Select
        labelId={labelId}
        label="Tipo de uso"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        {USAGE_TYPES.map((usageType) => (
          <MenuItem key={usageType} value={usageType}>
            {USAGE_TYPE_LABELS[usageType]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default UsageTypeSelect
